import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  key: 0,
  class: "header"
}
const _hoisted_3 = { class: "content__head" }
const _hoisted_4 = { class: "side-bar" }
const _hoisted_5 = { class: "right-bar" }
const _hoisted_6 = {
  class: "side-bar",
  ref: "sideBar"
}
const _hoisted_7 = { class: "right-bar" }

import VitaSubHeader from "@/components/VitaSubHeader.vue";
import VitaMainTable from "@/components/VitaMainTable.vue";
import VitaMainTableHead from "@/components/VitaMainTableHead.vue";
import VitaRightBar from "@/components/VitaRightBar.vue";
import VitaRightBarHead from "@/components/VitaRightBarHead.vue";
import VitaSideBarHead from "@/components/VitaSideBarHead.vue";
import VitaEmployee from "@/components/VitaEmployee.vue";
import { nextTick, onMounted, onUnmounted, ref, Ref, watch, watchEffect } from 'vue';
import router from "@/router";
import { useStore } from "vuex";
import { computed } from "vue";
import { NewUser } from "@/types";
import { isDevHost } from "@/utils/host";
import { isUserAuthenticated } from '@/utils/user';
import { useSavedMonth } from '@/composables/useSavedMonth';
import VitaSideNav from '@/components/VitaSideNav.vue';
import VitaEmployeeAdd from '@/components/VitaEmployeeAdd.vue';
import { PerfectScrollbarExpose } from 'vue3-perfect-scrollbar';

const containerLeftScrollGap = 91;


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const store = useStore();
const users = computed<NewUser[]>(() => {
  return store.getters["data/pharmUsers"];
});

const sidebarCollapsed = computed(() => {
  return store.getters['getSidebarState']
})

const table: Ref<PerfectScrollbarExpose | null> = ref(null);
const contentMainScroll: Ref<PerfectScrollbarExpose | null> = ref(null);
const tableHead: Ref<HTMLElement | null> = ref(null);
const tableScroll: Ref<HTMLElement | null> = ref(null);
const contentMain: Ref<HTMLElement | null> = ref(null);
const todayElement: Ref<HTMLElement | null> = ref(null);
const scrolled = ref<boolean>(false);
const dayFullElement: Ref<HTMLElement | null> = ref(null);
const arrowLeftActive = ref<boolean>(false);
const arrowRightActive = ref<boolean>(false);

const scrollEnd = () => {
  if (tableScroll.value) {
    tableScroll.value.scrollLeft += 5;
  }
};

const scrollStart = () => {
  if (tableScroll.value) {
    tableScroll.value.scrollLeft -= 5;
  }
};

let scrollInterval: number;

const scrollSmoothStart = (direction: number) => {
  if (!tableScroll.value) return;

  if (
    tableScroll.value.scrollLeft === tableScroll.value.scrollWidth ||
    tableScroll.value.scrollLeft < 0
  ) {
    scrollSmoothStop();
    return;
  }

  scrollInterval = setInterval(function () {
    if (direction === 1) {
      tableScroll.value ? (tableScroll.value.scrollLeft += 2.5) : null;
    } else {
      tableScroll.value ? (tableScroll.value.scrollLeft -= 2.5) : null;
    }
  }, 10);
};

const scrollSmoothStop = () => {
  clearInterval(scrollInterval);
};

const scrollYStart = () => {
  if (contentMain.value) {
    contentMain.value.scrollTop = 0;
  }
};

const scrollYEnd = () => {
  if (contentMain.value) {
    contentMain.value.scrollTop = contentMain.value.scrollHeight;
  }
};

const hoverRow = (index: number) => {
  store.commit("hoverRow", index);
};

const hover = computed<null | number>(() => {
  return store.getters["hover"];
});

const loader = computed<boolean>(() => {
  return store.getters["user/loader"];
});

const isOfflineDirectorRole = computed<boolean>(() => {
  return store.getters['getOfflineDirectorRole']
})

const hasUnsavedChanges = computed(() => {
  return store.getters['hasUnsavedChanges']
})

const { getSavedMonth } = useSavedMonth()

const getPharmacies = async () => {
  !loader.value ? store.commit("user/setLoader", true) : null;
  store.commit("setDate", new Date());
  getSavedMonth()
  await store.dispatch("user/userInfo");
  await store.dispatch("data/getPharmacies");
  await store.dispatch("data/getExternalUsers");
  await store.dispatch("data/getFondWorkTime");
  await store.dispatch("data/getHolidays");
  await store.dispatch("data/getShiftsExistence");
  await store.dispatch("data/getTimeScheduleDetails");
  await store.dispatch("data/getPastTimeScheduleDetails");
  await store.dispatch("data/getTimeSchedule");
  await store.dispatch("data/getPharmSchedule");
  await store.dispatch("data/getAdminShift", true);
  await store.dispatch("data/getFondWorkTimeHuman");
  store.commit("user/setLoader", false);
};
const token = localStorage.getItem("token");

const onScroll = () => {
  if (tableHead.value && tableScroll.value) {
    tableHead.value.scrollLeft = tableScroll.value.scrollLeft;
  }
  updateArrowVisibility();
};

watch(table, () => {
  tableScroll.value = document.querySelector(".table__scroll");
  contentMain.value = document.querySelector(".content__main");
  todayElement.value = tableScroll.value?.querySelector("td.today") || null;
  dayFullElement.value = tableScroll.value?.querySelector("td.day-warn") || null;
  updateArrowVisibility()
  if (contentMain.value) {
    scrolled.value = contentMain.value.scrollHeight > contentMain.value.clientHeight;
  }

  let scrollConfig: object = {behavior: "auto", block: "end", inline: "end"};

  if (new Date().getDate() <= 20) {
    scrollConfig = {behavior: "auto", block: "center", inline: "center"}
  }

  if (tableScroll.value) {
    todayElement.value?.scrollIntoView(scrollConfig)
  }
});

let observer: IntersectionObserver;
const handleIntersection = (entries: IntersectionObserverEntry[]) => {
  let hasVisible = false;

  entries.forEach((entry: IntersectionObserverEntry) => {
    if (entry.isIntersecting) {
      hasVisible = true;
    }
  });

  arrowLeftActive.value = arrowLeftActive.value && hasVisible;
  arrowRightActive.value = arrowRightActive.value && hasVisible;
};

const startIntersection = () => {
  if (tableHead.value && tableHead.value.querySelectorAll('.table__cell-warn').length > 0) {
    observer = new IntersectionObserver(handleIntersection, {
      root: tableHead.value,
      rootMargin: '0px',
      threshold: 0.1,
    });

    const dayElements = Array.from(tableHead.value.querySelectorAll('.table__cell-warn'));
    dayElements.forEach((el) => observer.observe(el));
  }
};

// Синхронизация плавной прокрутки скролла для tableScroll и tableHead
const smoothSyncScroll = (targetPosition: number, duration: number) => {
  if (!tableScroll.value) return;

  const startPosition = tableScroll.value.scrollLeft;
  const distance = targetPosition - startPosition;
  let startTime: number | null = null;

  // Сглаживание ease-in-out для плавной анимации
  const easeInOutQuad = (t: number): number => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2);

  const step = (currentTime: number) => {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const progress = Math.min(timeElapsed / duration, 1);
    const easedProgress = easeInOutQuad(progress);

    const newScrollLeft = startPosition + distance * easedProgress;

    // Обновляем scrollLeft для обоих элементов
    tableScroll.value ? tableScroll.value.scrollLeft = newScrollLeft : null
    tableHead.value ? tableHead.value.scrollLeft = newScrollLeft: null

    if (progress < 1) {
      requestAnimationFrame(step);
    }
  };

  requestAnimationFrame(step);
};

// Прокрутка к первому элементу с table__cell-warn слева
const scrollToLeftElement = () => {
  if (!tableHead.value || !tableScroll.value) return;

  const dayElements = Array.from(tableHead.value.querySelectorAll('.table__cell-warn'));
  for (let i = dayElements.length - 1; i >= 0; i--) {
    const rect = dayElements[i].getBoundingClientRect();
    const containerRect = tableHead.value.getBoundingClientRect();

    if (rect.right < (containerRect.left + containerLeftScrollGap)) {
      dayElements[i].scrollIntoView({ behavior: 'auto', block: 'center', inline: 'center' });
      smoothSyncScroll(tableHead.value.scrollLeft, 500)
      break;
    }
  }
};

// Прокрутка к первому элементу с table__cell-warn справа
const scrollToRightElement = () => {
  if (!tableHead.value || !tableScroll.value) return;

  const dayElements = Array.from(tableHead.value.querySelectorAll('.table__cell-warn'));
  for (let i = 0; i < dayElements.length; i++) {
    const rect = dayElements[i].getBoundingClientRect();
    const containerRect = tableHead.value.getBoundingClientRect();

    if (rect.left > containerRect.right) {
      dayElements[i].scrollIntoView({ behavior: 'auto', block: 'center', inline: 'center' });
      smoothSyncScroll(tableHead.value.scrollLeft, 500)
      break;
    }
  }
};

// Логика для обновления состояния стрелок
let dayElements = []
const updateArrowVisibility = () => {
  if (!tableHead.value || !tableScroll.value) {
    arrowLeftActive.value = false
    arrowRightActive.value = false
  }

  if (isOfflineDirectorRole.value || !tableHead.value || !tableScroll.value) return;

  const containerRect = tableHead.value.getBoundingClientRect();
  dayElements = Array.from(tableHead.value.querySelectorAll('.table__cell-warn'));

  let hasLeftInvisible = false;
  let hasRightInvisible = false;

  dayElements.forEach((el: HTMLElement) => {
    const rect = el.getBoundingClientRect();

    // Проверка элементов находящихся за пределами видимой области
    if (rect.right < (containerRect.left + containerLeftScrollGap)) {
      hasLeftInvisible = true;
    } else if (rect.left > containerRect.right) {
      hasRightInvisible = true;
    }
  });

  // Обновляем состояние стрелок в зависимости от наличия table__cell-warn в видимой области
  arrowLeftActive.value = hasLeftInvisible;
  arrowRightActive.value = hasRightInvisible;
};

// Отслеживание изменений в tableHead и tableScroll
watchEffect(async () => {
  await nextTick()
  if (tableHead.value && tableScroll.value) {
    startIntersection();
    updateArrowVisibility();
  }
});

if (isUserAuthenticated()) {
  router.push("/");
  getPharmacies();
} else {
  isDevHost() ? router.push({ name: "authentication-test" }) : router.push({ name: "authentication" })
}

const handleBeforeUnload = (event: BeforeUnloadEvent) => {
  if (hasUnsavedChanges.value) {
    event.preventDefault();
    event.returnValue = ''; // Необходимо для корректного отображения сообщения в браузере
  }
};

// Обновление скролла у графика при сворачивании/разворачивании сайдбара (flush обязателен для корректного пересчёта геометрии)
watch(sidebarCollapsed, () => {
  contentMainScroll.value?.ps?.update();
  table.value?.ps?.update();
  onScroll();
}, { flush: 'post' });

onMounted(() => {
  window.addEventListener('beforeunload', handleBeforeUnload);
});

onUnmounted(() => {
  window.removeEventListener('beforeunload', handleBeforeUnload);
});

return (_ctx: any,_cache: any) => {
  const _component_vita_month_changer = _resolveComponent("vita-month-changer")!
  const _component_PerfectScrollbar = _resolveComponent("PerfectScrollbar")!
  const _component_vita_icon = _resolveComponent("vita-icon")!
  const _component_perfect_scrollbar = _resolveComponent("perfect-scrollbar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["home", { 'collapsed': sidebarCollapsed.value }])
  }, [
    (!loader.value && (_unref(token) && users.value))
      ? (_openBlock(), _createBlock(VitaSideNav, { key: 0 }))
      : _createCommentVNode("", true),
    (!loader.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_unref(token) && users.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(VitaSubHeader)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "content",
            style: _normalizeStyle('--users-count:' + users.value.length)
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["table__arrow table__arrow-left", {'table__arrow-visible': arrowLeftActive.value, 'table__arrow-sm' : users.value.length < 3}]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (scrollToLeftElement())),
              title: "Необходимо исправить время",
              "data-qa": "home-arrow-scroll-left"
            }, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("svg", {
                width: "6",
                height: "10",
                viewBox: "0 0 6 10",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  d: "M0 5L5.05735 0L6 0.931958L1.88528 5L6 9.06804L5.05735 10L0 5Z",
                  fill: "#FF3B30"
                })
              ], -1),
              _createElementVNode("span", null, "Необходимо исправить время", -1),
              _createElementVNode("svg", {
                width: "6",
                height: "10",
                viewBox: "0 0 6 10",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  d: "M0 5L5.05735 0L6 0.931958L1.88528 5L6 9.06804L5.05735 10L0 5Z",
                  fill: "#FF3B30"
                })
              ], -1)
            ]))], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["table__arrow table__arrow-right", {'table__arrow-visible': arrowRightActive.value, 'table__arrow-sm' : users.value.length < 3}]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (scrollToRightElement())),
              title: "Необходимо исправить время",
              "data-qa": "home-arrow-scroll-right"
            }, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("svg", {
                width: "6",
                height: "10",
                viewBox: "0 0 6 10",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  d: "M6 5L0.942651 10L4.07372e-08 9.06804L4.11472 5L3.96377e-07 0.931957L0.942652 4.12046e-08L6 5Z",
                  fill: "#FF3B30"
                })
              ], -1),
              _createElementVNode("span", null, "Необходимо исправить время", -1),
              _createElementVNode("svg", {
                width: "6",
                height: "10",
                viewBox: "0 0 6 10",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  d: "M6 5L0.942651 10L4.07372e-08 9.06804L4.11472 5L3.96377e-07 0.931957L0.942652 4.12046e-08L6 5Z",
                  fill: "#FF3B30"
                })
              ], -1)
            ]))], 2),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_vita_month_changer),
                _createVNode(VitaSideBarHead)
              ]),
              _createElementVNode("div", {
                class: "table__scroll-hidden",
                ref_key: "tableHead",
                ref: tableHead
              }, [
                _createVNode(VitaMainTableHead)
              ], 512),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(VitaRightBarHead)
              ])
            ]),
            _createVNode(_component_perfect_scrollbar, {
              onPsScrollY: onScroll,
              ref_key: "contentMainScroll",
              ref: contentMainScroll,
              class: "content__main"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (user, index) => {
                    return (_openBlock(), _createBlock(VitaEmployee, {
                      onMouseover: ($event: any) => (hoverRow(index)),
                      class: _normalizeClass({ hover: hover.value === index }),
                      key: `${user.id}-${index}`,
                      number: user.bid,
                      name: user.name,
                      position: user.position,
                      "zup-guid": user.zupGuid,
                      "new-user": user.newUser,
                      external: user.externalUser,
                      phone: user.phone ?? null,
                      "date-employment": user.dateOfEmployment ?? null,
                      "pst-user": user.profiPstUser
                    }, null, 8, ["onMouseover", "class", "number", "name", "position", "zup-guid", "new-user", "external", "phone", "date-employment", "pst-user"]))
                  }), 128)),
                  _createVNode(VitaEmployeeAdd)
                ], 512),
                _createVNode(_component_PerfectScrollbar, {
                  onPsScrollX: onScroll,
                  ref_key: "table",
                  ref: table,
                  class: "table__scroll"
                }, {
                  default: _withCtx(() => [
                    _createVNode(VitaMainTable)
                  ]),
                  _: 1
                }, 512),
                _createVNode(_component_vita_icon, {
                  class: "table__scroll-bar-controll table__scroll-bar-start",
                  "data-qa": "home-icon-scroll-table-start",
                  onClick: scrollStart,
                  onMousedown: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (scrollSmoothStart(-1)), ["prevent"])),
                  onMouseup: scrollSmoothStop,
                  onMouseout: scrollSmoothStop,
                  name: "chevron-left"
                }),
                _createVNode(_component_vita_icon, {
                  class: "table__scroll-bar-controll table__scroll-bar-end",
                  "data-qa": "home-icon-scroll-table-end",
                  onClick: scrollEnd,
                  onMousedown: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (scrollSmoothStart(1)), ["prevent"])),
                  onMouseup: scrollSmoothStop,
                  onMouseout: scrollSmoothStop,
                  name: "chevron-left"
                }),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(VitaRightBar)
                ]),
                (scrolled.value)
                  ? (_openBlock(), _createBlock(_component_vita_icon, {
                      key: 0,
                      class: "content__main__scroll-bar-controll content__main__scroll-bar-start",
                      "data-qa": "home-icon-scroll-content-start",
                      onClick: scrollYStart,
                      name: "chevron-bot"
                    }))
                  : _createCommentVNode("", true),
                (scrolled.value)
                  ? (_openBlock(), _createBlock(_component_vita_icon, {
                      key: 1,
                      class: "content__main__scroll-bar-controll content__main__scroll-bar-end",
                      "data-qa": "home-icon-scroll-content-end",
                      onClick: scrollYEnd,
                      name: "chevron-bot"
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 512)
          ], 4)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})